import { Brandmark } from "../components/Brandmark.js";
import { Icon } from "../components/Icon.js";
import { loginUrl } from "../auth/authClient.js";

export default function Login() {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        background: "var(--canvas)",
      }}
    >
      <div style={{ padding: "28px 36px", display: "flex", alignItems: "center", gap: 12 }}>
        <Brandmark size={40} />
        <div style={{ fontFamily: "Fraunces, serif", fontSize: 24, letterSpacing: "-0.01em" }}>
          KBank
        </div>
      </div>
      <div
        style={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "40px 36px 80px",
        }}
      >
        <div className="fadein" style={{ maxWidth: 420, width: "100%", textAlign: "center" }}>
          <div
            style={{
              width: 72,
              height: 72,
              borderRadius: "50%",
              background: "var(--brand-soft)",
              color: "var(--brand)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 16px",
            }}
          >
            <Icon name="lock" size={32} />
          </div>
          <h1 style={{ marginBottom: 8 }}>Sign in</h1>
          <p className="soft" style={{ fontSize: 15, marginBottom: 28 }}>
            Sign in with the Microsoft account that's set up for you.
          </p>
          <a
            href={loginUrl()}
            className="btn btn-brand btn-lg"
            style={{ width: "100%", maxWidth: 320 }}
          >
            Sign in with Microsoft
          </a>
        </div>
      </div>
      <div
        className="center"
        style={{ padding: "16px 0 24px", fontSize: 11, color: "var(--ink-mute)" }}
      >
        KBank keeps your money safe.
      </div>
    </div>
  );
}
